import Button from 'shopper/components/Button';
import Heading from 'shopper/components/Heading';

import Image from 'components/Image';

import { sendEvent } from 'lib/gtag';
import placeholder from 'lib/placeholder';
import { scrollToElement } from 'lib/utils';

import APP from 'constants/app';

const Hero = ({ gaEventCategory }) => {
  const onGetInTouchClick = () => {
    const form = document.querySelector('#fazer_parceria');

    sendEvent({
      action: 'see_commercial_lp',
      category: gaEventCategory,
    });
    scrollToElement(form.offsetTop);
  };

  return (
    <section className="flex items-center justify-between gap-x-6">
      <div className="flex w-full flex-col items-center lg:items-start">
        <Image
          alt="Promobit Ads"
          className="lg:h-18 lg:w-[414px]"
          height={40}
          src={`${APP.LOCAL_IMAGE_PATH}/features/commercial-partners/promobit-ads.svg`}
          width={230}
          priority
        />
        <Heading className="mb-6 mt-2 text-neutral-high-500 lg:my-8">
          Conecte sua marca a
          <br />
          <Heading as="span" className="text-gradient-highlight">
            +3 milhões de pessoas
          </Heading>
          <br />
          loucas por promoção!
        </Heading>
        <Heading className="mb-4 text-center lg:hidden" size="size5">
          Soluções para vender mais para
          <br />
          <Heading as="span" className="text-gradient-highlight" size="size5">
            escalar o ROI.
          </Heading>
        </Heading>
        <Button size="size1" type="secondary" full onClick={onGetInTouchClick}>
          {placeholder('actions.getInTouch')}
        </Button>
      </div>
      <Image
        alt="Pessoa conhecendo as vantagens de ser um parceiro do Promobit"
        className="hidden lg:block dark:lg:hidden"
        height={624}
        src={`${APP.LOCAL_IMAGE_PATH}/features/commercial-partners/hero-v2@light.png`}
        width={663}
        priority
      />
      <Image
        alt="Pessoa conhecendo as vantagens de ser um parceiro do Promobit"
        className="hidden dark:lg:block"
        height={624}
        src={`${APP.LOCAL_IMAGE_PATH}/features/commercial-partners/hero@dark.png`}
        width={663}
      />
    </section>
  );
};

export default Hero;
